import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import _ from 'lodash';
import { Subject } from 'rxjs';
import { fadeInUp400ms } from 'src/@smartmanufacturing/animations/fade-in-up.animation';
import { scaleFadeIn400ms } from 'src/@smartmanufacturing/animations/scale-fade-in.animation';
import { stagger20ms } from 'src/@smartmanufacturing/animations/stagger.animation';
import { TableColumn } from 'src/@smartmanufacturing/interfaces/table-column.interface';
import { TreeNode } from 'primeng/api';

interface Column {
  field: string;
  header: string;
}

@Component({
  selector: 'app-manage-role-permission-expandable',
  templateUrl: './manage-role-permission-expandable.component.html',
  styleUrls: ['./manage-role-permission-expandable.component.scss'],
  animations: [
    stagger20ms,
    fadeInUp400ms,
    scaleFadeIn400ms
  ]
})
export class ManageRolePermissionExpandableComponent<T> implements OnInit, OnChanges, OnDestroy {
  @Input() data: any;
  @Input() columns: TableColumn<T>[];
  @Input() pageSize = 20;
  @Input() pageSizeOptions = [10, 20, 50];
  @Input() sectionId: number = 0;
  @Input() sectionSelected: boolean = false;


  private destroy$: Subject<void> = new Subject<void>();
  checked: boolean = false;
  files!: TreeNode[];
  selectedNodes3: TreeNode[];
  files5: TreeNode[];
  cols!: Column[];
  treeData: TreeNode[];
  constructor() { }

  ngOnInit() {
    this.cols = [
      { field: 'label', header: 'Name' },
      { field: 'isWrite', header: 'Write' },
      { field: 'isRead', header: 'Read' },
      { field: 'isUpdate', header: 'Update' },
      { field: 'isDelete', header: 'Delete' },
      { field: 'isApprove', header: 'Approve' },
      { field: 'isReject', header: 'Reject' },
      { field: 'isActivate', header: 'Activate' },
      { field: 'isDeactivate', header: 'DeActive' }
    ];

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.treeData = this.data[0].data;
    }
  }

  updateData(node: any, isSelected: boolean, type: string): void {
    if (type == 'multiSelect') {
      if (node.data) {
        node.data.isActivate = isSelected;
        node.data.isApprove = isSelected;
        node.data.isDelete = isSelected;
        node.data.isDeactivate = isSelected;
        node.data.isUpdate = isSelected;
        node.data.isRead = isSelected;
        node.data.isReject = isSelected;
        node.data.isWrite = isSelected;
        node.data.isSelected = isSelected;
      }
    }

    if (node.children) {
      node.children.forEach((child: any) => {
        this.updateData(child, isSelected, 'multiSelect'); // Recursively update child nodes
      });
    }
  }

  updateParentNodes(treeData: any, isSelected: boolean): void {
    if (treeData.parent) {
      const isAnyChildSelected = treeData.parent.children.some((child: any) => child.data.isSelected);
      treeData.parent.data.isSelected = isAnyChildSelected;

      this.updateParentNodes(treeData.parent, isSelected);
    }
  }

  checkedData(treeData: any, type: string): void {
    if (type === 'link' || type === 'dropdown') {
      if (treeData.parent.children.some((child: any) => child.data.isSelected === true)) {
        treeData.parent.data.isSelected = true;
        if (treeData.node.parent.parent) {
          treeData.node.parent.parent.data.isSelected = true;
          treeData.node.parent.data.isSelected = true;
        }
      }
    } else {
      this.updateData(treeData.node, true, 'multiSelect');
      this.updateParentNodes(treeData, true);
    }
  }

  uncheckedData(treeData: any, type: string): void {
    if (type === 'link' || type === 'dropdown') {
      if (treeData.parent.children.every((child: any) => child.data.isSelected === false)) {
        treeData.parent.data.isSelected = false;
        if (treeData.node.parent.parent) {
          treeData.node.parent.parent.data.isSelected = false;
        }
      }
    } else {
      this.updateData(treeData.node, false, 'multiSelect');
      this.updateParentNodes(treeData, false);
    }
  }

  nodeSelect(event: any, treeData: any): void {
    if (treeData.node.data.disabled) {
      event.preventDefault();
      return;
    }

    const isSelected = event.currentTarget.checked === true;

    if (treeData.node.data.type === 'dropdown' || treeData.node.data.type === 'subheading') {
      treeData.node.children.forEach((element: any) => {
        this.updateData(element, isSelected, 'multiSelect');
      });
      this.updateParentNodes(treeData, isSelected);
    } else {
      this.updateData(treeData.node, isSelected, 'multiSelect');
      this.updateParentNodes(treeData, isSelected);
    }
  }

  onChange(event: any, type: string): void {
    if (event.node.data.disabled) {
      return;
    }

    const isSelected =
      event.node.data.isActivate ||
      event.node.data.isApprove ||
      event.node.data.isDelete ||
      event.node.data.isDeactivate ||
      event.node.data.isUpdate ||
      event.node.data.isRead ||
      event.node.data.isReject ||
      event.node.data.isWrite;

    event.node.data.isSelected = isSelected;
    this.updateData(event.node, isSelected, type);
    this.updateParentNodes(event, isSelected);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
